module.exports = __webpack_public_path__ + "media/images/flags/4x3/bvt-a0dbef9df125c12ab6a50b8a41202e61.svg";